export interface Character {
	origin: string;
	group: string;
	name: string;
	nick: string;
	unit: string;
	str: [string, string];
	dex: [string, string];
	con: [string, string];
	per: [string, string];
	tough: [string, string];
	edu: [string, string];
	health: [string, string];
	morale: [string, string];
	will: [string, string];
	zero: [string, string];
	luckPoints: [string, string];
	expertisePoints: [string, string];
	acrobatics: [boolean, string];
	athletics: [boolean, string];
	archeology: [boolean, string];
	firearms: [boolean, string];
	eye: [boolean, string];
	electric: [boolean, string];
	history: [boolean, string];
	intuition: [boolean, string];
	pockerface: [boolean, string];
	breathcontrol: [boolean, string];
	technique: [boolean, string];
	mechanic: [boolean, string];
	medicine: [boolean, string];
	nature: [boolean, string];
	navigation: [boolean, string];
	woundtending: [boolean, string];
	persuasion: [boolean, string];
	survival: [boolean, string];
	leadership: [boolean, string];
	psychology: [boolean, string];
	crafting: [boolean, string];
	investigate: [boolean, string];
	hiding: [boolean, string];
	melee: [boolean, string];
	luck: [boolean, string];
	expertise: [boolean, string];
	skills: string[];
	items: string[];
	body: {
		head: {
			p: string;
			t: string;
			w: string;
		},
		chest: {
			p: string;
			t: string;
			w: string;
		},
		righthand: {
			p: string;
			t: string;
			w: string;
		},
		lefthand: {
			p: string;
			t: string;
			w: string;
		},
		legs: {
			p: string;
			t: string;
			w: string;
		},
		feet: {
			p: string;
			t: string;
			w: string;
		}
	}
	notes: string;
}

export const defaultCharacter: Character = {
	origin: "",
	group: "",
	name: "",
	nick: "",
	unit: "",
	str: ["", ""],
	dex: ["", ""],
	con: ["", ""],
	per: ["", ""],
	tough: ["", ""],
	edu: ["", ""],
	health: ["", ""],
	morale: ["", ""],
	will: ["", ""],
	zero: ["", ""],
	luckPoints: ["", ""],
	expertisePoints: ["", ""],
	acrobatics: [false, ""],
	athletics: [false, ""],
	archeology: [false, ""],
	firearms: [false, ""],
	eye: [false, ""],
	electric: [false, ""],
	history: [false, ""],
	intuition: [false, ""],
	pockerface: [false, ""],
	breathcontrol: [false, ""],
	technique: [false, ""],
	mechanic: [false, ""],
	medicine: [false, ""],
	nature: [false, ""],
	navigation: [false, ""],
	woundtending: [false, ""],
	persuasion: [false, ""],
	leadership: [false, ""],
	psychology: [false, ""],
	crafting: [false, ""],
	investigate: [false, ""],
	survival: [false, ""],
	hiding: [false, ""],
	melee: [false, ""],
	luck: [false, ""],
	expertise: [false, ""],
	skills: Array(20).fill(""),
	items: Array(40).fill(""),
	body: {
		head: {
			p: "",
			t: "",
			w: "",
		},
		chest: {
			p: "",
			t: "",
			w: "",
		},
		righthand: {
			p: "",
			t: "",
			w: "",
		},
		lefthand: {
			p: "",
			t: "",
			w: "",
		},
		legs: {
			p: "",
			t: "",
			w: "",
		},
		feet: {
			p: "",
			t: "",
			w: "",
		}
	},
	notes: "",
}
